import Settings from './Setting';
import CommonReducer from './CommonReducer';
import Auth from './Auth';
import TenantReducer from './TenantReducer';

const reducers = {
  settings: Settings,
  auth: Auth,
  common: CommonReducer,
  tenant: TenantReducer,
};

export default reducers;
